<template>
  <c-search-form :input-search-items="searchItems"
                 :form-name="formName"
                 :hiddenFields="hiddenFields"
                 model="searchForm" :fields="fields"
                 key-property="logId"
                 :search-url="searchUrl"
                 :accept-create="false"
                 :accept-delete="false"
  >
  </c-search-form>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";

export default {
  name: 'log-management',
  components: {CSearchForm},
  data: () => {
    return {
      formName: "Tra cứu mã dự thưởng chương trình Tết",
      searchUrl: null,
      searchItems: [
        {
          type: "text",
          name: "phone",
          label: "Số điện thoại",
          placeHolder: "",
          focus: true
        },
      ],
      fields: [
        {
          value: "no",
          text: "lang.common.index",
          width: "3%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'username',
          text: 'username',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'accountName',
          text: 'Tên học sinh',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'code',
          text: 'Mã dự thưởng',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'dateLearn',
          text: 'Ngày học',
          width: "5%",
          sortable: false,
          dateFormat: 'dd/MM/yyyy',
          headerStyle: "text-align:left"
        },
        {
          value: 'product',
          text: 'Ứng dụng',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
      ]
    }
  },
  methods: {
  },
  created() {
    this.searchUrl = "/kidEventTet2024/searchEventTet2024ByPhone?sortField=status,classId&";
  }

}
</script>
